import { Navigate, Route } from 'react-router-dom';

/**
 * Legacy route redirects, exported as the actual `<Route>` elements that App.tsx
 * renders. Exporting the shipped element (path + target + `replace`) - rather
 * than re-declaring an equivalent in a test - means the redirect regression test
 * consumes exactly what production ships and cannot drift from it (Rule 46: a
 * test that mounts its own inline <Navigate> is a vacuous guard).
 *
 * `/me/notifications` -> `/settings/notifications`: the notification surfaces
 * were consolidated to a single page (#2652); this preserves the old bookmarked
 * URL. `replace` is load-bearing so Back does not bounce off the redirect.
 */
export const meNotificationsRedirectRoute = (
  <Route path="me/notifications" element={<Navigate to="/settings/notifications" replace />} />
);
